import { Text } from "@prismicio/editor-ui"

interface Props {
  count: number
}

export function AssetCount(props: Props) {
  const { count } = props

  return (
    <Text variant="bold">
      {count} item{count == 1 ? "" : "s"}
    </Text>
  )
}
